"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var BottomExtraSpace = /*#__PURE__*/function (_Component) {
  _inherits(BottomExtraSpace, _Component);

  function BottomExtraSpace(props) {
    var _this;

    _classCallCheck(this, BottomExtraSpace);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BottomExtraSpace).call(this, props));
    _this.ref = _react2["default"].createRef();
    _this.state = {
      mounted: false
    };
    _this.el = document.createElement('div');
    return _this;
  }

  _createClass(BottomExtraSpace, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fixedRoot = this.ref.current;

      while (this.fixedRoot && window.getComputedStyle(this.fixedRoot).getPropertyValue('overflow') !== 'auto') {
        this.fixedRoot = this.fixedRoot.parentElement;
      }

      if (!this.fixedRoot) this.fixedRoot = document.body;
      this.fixedRoot && this.fixedRoot.appendChild(this.el);
      this.setState({
        mounted: true
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.fixedRoot && this.fixedRoot.removeChild(this.el);
    }
  }, {
    key: "render",
    value: function render() {
      var mounted = this.state.mounted;
      if (!mounted) return _react2["default"].createElement("div", {
        ref: this.ref
      });
      var children = this.props.children;
      return _reactDom2["default"].createPortal(_react2["default"].createElement("div", {
        className: "o-0",
        tabIndex: "-1"
      }, children), this.el);
    }
  }]);

  return BottomExtraSpace;
}(_react.Component);

BottomExtraSpace.propTypes = {
  children: _propTypes2["default"].node
};
exports["default"] = BottomExtraSpace;